import { Component, HostListener } from '@angular/core';
import { environment } from 'src/environments/environment';
import { LocalizationService } from './core/services/localization/localization.service';
import { NavigationEnd, Router } from '@angular/router';
import { CookieConsentService } from './core/services/cookie-consent/cookie-consent.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'EWS';
  lang: string = environment.defaultLang;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      document.body.scrollTop > 50 ||
      document.documentElement.scrollTop > 50
    ) {
      document.getElementById('navber')?.classList.add('red');
    } else {
      document.getElementById('navber')?.classList.remove('red');
    }
  }

  constructor(
    private router: Router,
    private localization: LocalizationService,
    private cookieConsent: CookieConsentService
  ) {
    this.localization.init();
    this.localization.addLang(['en', 'ar']);
    this.localization.onLangChange().subscribe(() => {
      // this.setRtlClass();
    });
   }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.cookieConsent.showIfNeeded();
    this.router.events.subscribe((e) => {
      if (!(e instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
